'use client';

import { useSpotMarketsSortedByMarketIndex } from '../spotMarkets/useSpotMarketsSortedByMarketIndex';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

const useSwapMarkets = () => {
	const { fromMarketIndex, toMarketIndex } = useVelocityStore((s) => s.swap);
	const spotMarketsSortedByMarketIndex = useSpotMarketsSortedByMarketIndex();
	const swapFromMarket = spotMarketsSortedByMarketIndex[fromMarketIndex];
	const swapToMarket = spotMarketsSortedByMarketIndex[toMarketIndex];

	return { swapFromMarket, swapToMarket };
};

export default useSwapMarkets;
